import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Ensure AOS is imported
import { Link } from "react-router";

const Portfolio = (props) => {
  const { fullImage = true, moreDetails = false, contact = false } = props;
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <section id="portfolio" className="portfolio section">
      <div className="container section-title" data-aos="fade-up">
        <h2>{props?.portfolioHeader}</h2>
        <p>
          <b>{props?.description}</b>
        </p>
      </div>
      {contact ? (
        <div className="spread-smiles-contact" data-aos="fade-up">
          <div className="container">
            <h2>Want to spread smiles?</h2>
            <p>
              Celebrate your special day with us — reach out and share the joy!
            </p>
            <Link to="/contact" className="contact-btn">
              <h3>Contact Us</h3>
            </Link>
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="container">
        <div
          className="isotope-layout"
          data-default-filter="*"
          data-layout="masonry"
          data-sort="original-order"
        >
          <div
            className="row gy-4 isotope-container"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            {props.portfolioImage &&
              props.portfolioImage?.map((item, index) => (
                <div
                  key={index}
                  className={`col-lg-4 col-md-6 portfolio-item isotope-item filter-app`}
                >
                  <img src={item.img} className="img-fluid" alt={item.title} />
                  <div className="portfolio-info">
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                    <a
                      href={item.img}
                      title={item.title}
                      data-gallery="portfolio-gallery-app"
                      className="glightbox preview-link"
                    >
                      {fullImage && <i className="bi bi-zoom-in"></i>}
                    </a>
                    {moreDetails && (
                      <Link
                        to={item.link ?? "#"}
                        title={item.title}
                        className="details-link"
                      >
                        <i className="bi bi-link-45deg"></i>
                      </Link>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
